module.exports = __webpack_public_path__ + "2023124:cb48231cec1aa2d91890/img/HomeScreen-Devices-S.1c44e60.png";